import React from 'react';
import { useLanguage } from '@/context/LanguageContext';
import RendezVousButton from '../ui/RendezVousButton';

interface ModernStyleSectionProps {
  onRendezVousClick?: () => void;
}

const ModernStyleSection: React.FC<ModernStyleSectionProps> = ({ onRendezVousClick }) => {
  const { language, tl } = useLanguage();

  return (
    <section className="relative py-0 bg-white min-h-[400px] flex items-center justify-center">
      {/* Full-width background image */}
      <img
        src="/interior-design-neoclassical-style-with-furnishings-decor_23-2151199323.jpg"
        alt={tl('Aperçu du service design', 'Design Service Devices', 'Anteprima del servizio design')}
        className="absolute inset-0 w-full h-full object-cover z-0"
      />
      {/* Optional: dark overlay for readability */}
      <div className="absolute inset-0 bg-black/40 z-10" />
      {/* Centered content */}
      <div className="relative z-20 flex flex-col items-center justify-center w-full px-4 py-16">
        <span className="text-white font-bold tracking-widest text-sm uppercase drop-shadow-lg mb-2">
          {tl('SERVICE DESIGN', 'DESIGN SERVICE', 'SERVIZIO DESIGN')}
        </span>
        <h2 className="text-3xl md:text-5xl text-white font-sans font-bold mb-4 leading-tight drop-shadow-lg">
          {tl("Besoin d'aide ?", 'Do you need any help?', 'Avete bisogno di aiuto?')}
        </h2>
        <p className="text-lg md:text-xl text-white font-medium mb-6 md:mb-8 uppercase tracking-wide text-center drop-shadow-lg">
          {language === 'fr' ? (
            <>
              PRENEZ RENDEZ-VOUS EN MAGASIN <br /> OU <br /> OPTEZ POUR UN APPEL VIDÉO POUR EXPLORER LES PRODUITS QUI VOUS INTÉRESSENT.
            </>
          ) : language === 'it' ? (
            <>
              PRENOTATE UN APPUNTAMENTO IN NEGOZIO <br /> O <br /> OPTATE PER UNA VIDEOCHIAMATA PER ESPLORARE I PRODOTTI CHE VI INTERESSANO.
            </>
          ) : (
            <>
              FEEL FREE TO SCHEDULE AN IN-STORE APPOINTMENT <br /> OR<br />
              A CONVENIENT VIDEO CALL TO FURTHER EXPLORE THE PRODUCTS YOU ARE MOST INTERESTED IN.
            </>
          )}
        </p>
        <div className="w-full flex flex-col sm:flex-row sm:items-center gap-4 max-w-xs mx-auto">
          <RendezVousButton onClick={onRendezVousClick}>
            {tl('Prendre Rendez-vous', 'Book an Appointment', 'Prenota un appuntamento')}
          </RendezVousButton>
        </div>
      </div>
    </section>
  );
};

export default ModernStyleSection;
